import React from 'react';
import PropTypes from 'prop-types';
import DocumentItem from './DocumentItem';
import IdentityItem from './IdentityItem';
import BundleItem from './BundleItem';
import ErrorItem from './ErrorItem';

const NotificationList = ({ markAsRead, notificationsList }) => {
  return notificationsList.filter(el => el.visible).map((notif) => {
    const data = JSON.parse(notif.data);
    const id = notif.id;

    if (notif.type === 'identity') {
      return <IdentityItem key={id} notif={notif} markAsRead={markAsRead} data={data} />;
    } else if (notif.type === 'document') {
      return <DocumentItem key={id} notif={notif} markAsRead={markAsRead} data={data} />;
    } else if (notif.type === 'bundle') {
      return <BundleItem key={id} notif={notif} markAsRead={markAsRead} data={data} />;
    } else if (notif.type === 'audit') {
      return <ErrorItem key={id} notif={notif} markAsRead={markAsRead} data={data} />;
    } else {
      return <div />;
    }
  });
};

NotificationList.Proptypes = {
  markAsRead: PropTypes.func,
  notificationsList: PropTypes.array1
};
export default NotificationList;
